export const zhCnLocale = {
  model: {
    contactForm: '联系表单'
  },
  contactForm: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    city: '城市',
    email: '邮箱',
    name: '名称',
    wechatId: '微信ID',
    phone: '手机号码',
    profession: '职业',
    countryId: 'Country',
    storeId: 'Store',
    userId: 'User',
    country: '国家',
    store: '店铺',
    user: '用户',
  }
}

export const enLocale = {
  model: {
    contactForm: 'Contact form'
  },
  contactForm: {
    id: 'ID',
    createdAt: 'Created At',
    updatedAt: 'Updated at',
    city: 'City',
    email: 'Email',
    name: 'Name',
    wechatId: 'Wechat',
    phone: 'Phone',
    profession: 'Profession',
    countryId: 'Country',
    storeId: 'Store',
    userId: 'User',
    country: 'Country',
    store: 'Store',
    user: 'User',
  }
}

